import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createLogger } from '../../app/logger'
import { RootState } from '../../app/store'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'SseSlice'
})

export type SseState = {
  sseMessageReceivedButEntriesUrlIsUndefined: boolean
  sseOpen?: boolean
}

const initialState: SseState = {
  sseMessageReceivedButEntriesUrlIsUndefined: false,
  sseOpen: false,
}

export const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    setSseMessageReceivedButEntriesUrlIsUndefined: (state, action: PayloadAction<boolean>) => {
      state.sseMessageReceivedButEntriesUrlIsUndefined = action.payload
    },
    setSseOpen: (state, action: PayloadAction<boolean | undefined>) => {
      state.sseOpen = action.payload
    },
  }
})

export const {
  setSseMessageReceivedButEntriesUrlIsUndefined,
  setSseOpen,
} = sseSlice.actions

export const getSseMessageReceivedButEntriesUrlIsUndefined = (state: RootState) => state.sse.sseMessageReceivedButEntriesUrlIsUndefined
export const getSseOpen = (state: RootState) => state.sse.sseOpen

export default sseSlice.reducer
